import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/layout/index.vue'
import Login from '../views/login'
import store from '../store/index.js'
Vue.use(VueRouter)

function pageComponent (path) {
  return resolve => require([`@/views/${path}/index`], resolve)
}
const routes = [
  {
    path: '/',
    component: Main,
    redirect: '/console',
    children: [
      // 控制台
      {
        path: '/console',
        name: 'console',
        component: pageComponent('console')
      },
      // 手机号画像
      {
        path: '/riskPhone',
        name: 'riskPhone',
        component: pageComponent('riskPhone')
      },
      // 境外手机号画像
      {
        path: '/riskPhoneOverseas',
        redirect: {
          name: 'riskPhone',
          params: {
            busi: 'heika_without_mainland_offline'
          }
        }
      },
      // 手机号攻击情报
      {
        path: '/riskPhoneAttackMonitor',
        name: 'riskPhoneAttackMonitor',
        component: pageComponent('riskPhoneAttackMonitor')
      },
      // 金融反欺诈画像
      {
        path: '/financialAntiFraud',
        name: 'financialAntiFraud',
        component: pageComponent('financialAntiFraud')
      },
      // 邮箱画像
      {
        path: '/riskMailbox',
        name: 'riskMailbox',
        component: pageComponent('riskMailbox')
      },
      // 风险IP画像
      {
        path: '/riskIp',
        name: 'riskIp',
        component: pageComponent('riskIp')
      },
      // 移动风险感知平台
      // {
      //   path: '/riskMobile',
      //   name: 'riskMobile',
      //   component: pageComponent('riskMobile')
      // },
      // 移动风险感知平台
      {
        path: '/riskMobile/beta',
        name: 'riskMobile',
        component: pageComponent('riskMobileBeta')
      },
      // 配置页面
      {
        path: '/configure',
        name: 'configure',
        component: pageComponent('configure')
      },
      // 手机号反馈页面
      {
        path: '/phoneFeedback',
        name: 'phoneFeedback',
        component: pageComponent('phoneFeedback')
      }
    ]
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '*',
    redirect: '/console'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  await store.dispatch('init')
  if (!store.state.isLogin) {
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
  } else {
    await store.dispatch('getProductData')
    if (to.path === '/login') {
      next('/')
      return
    }
    next()
  }
})

export default router
